module.exports = __webpack_public_path__ + "static/patience-43d8017e6dea81e57ae11e5e65a76c91.png";